(() => {
  function initCTS(sectionEl) {
    if (!sectionEl) return;

    // Prevent double init
    if (sectionEl.dataset.ctsInit === "1") return;
    sectionEl.dataset.ctsInit = "1";

    const tabs = Array.from(sectionEl.querySelectorAll("[data-cts-tab]"));
    const panels = Array.from(sectionEl.querySelectorAll("[data-cts-panel]"));

    if (!tabs.length || !panels.length) return;

    const setActive = (blockId) => {
      tabs.forEach((btn) => {
        const active = btn.dataset.ctsTarget === blockId;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
      });

      panels.forEach((panel) => {
        const active = panel.getAttribute("data-cts-panel") === blockId;
        panel.classList.toggle("is-active", active);

        if (active) {
          panel.hidden = false;

          // refresh dots for the active slider
          const slider = panel.querySelector("[data-cts-slider]");
          if (slider) refreshDots(slider);
        } else {
          panel.hidden = true;
        }
      });
    };

    // Tabs click (pointerdown works well on mobile too)
    tabs.forEach((btn) => {
      btn.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        setActive(btn.dataset.ctsTarget);
      });
    });

    // Sliders per panel
    sectionEl.querySelectorAll("[data-cts-slider]").forEach((slider) => {
      const track = slider.querySelector("[data-cts-track]");
      const prev = slider.querySelector("[data-cts-prev]");
      const next = slider.querySelector("[data-cts-next]");

      if (!track) return;

      // Scroll by "page" (almost one viewport)
      const scrollByPage = (dir) => {
        const page = track.clientWidth; // one full viewport
        track.scrollBy({ left: dir * page, behavior: "smooth" });
      };

      prev && prev.addEventListener("click", () => scrollByPage(-1));
      next && next.addEventListener("click", () => scrollByPage(1));

      track.addEventListener(
        "scroll",
        () => updateActiveDot(slider),
        { passive: true }
      );

      window.addEventListener("resize", () => refreshDots(slider));
      refreshDots(slider);
    });

    // Ensure first tab is active on load
    setActive(tabs[0].dataset.ctsTarget);
  }

  function refreshDots(slider) {
    const track = slider.querySelector("[data-cts-track]");
    const dotsWrap = slider.querySelector("[data-cts-dots]");
    const prev = slider.querySelector("[data-cts-prev]");
    const next = slider.querySelector("[data-cts-next]");
    if (!track || !dotsWrap) return;

    const maxScroll = track.scrollWidth - track.clientWidth;

    dotsWrap.innerHTML = "";

    // Always show at least 1 dot
    const pages =
      maxScroll <= 5
        ? 1
        : Math.max(2, Math.round(track.scrollWidth / track.clientWidth));

    for (let i = 0; i < pages; i++) {
      const dot = document.createElement("span");
      dot.className = "cts__dot" + (i === 0 ? " is-active" : "");
      dotsWrap.appendChild(dot);
    }

    // Disable arrows if only one page
    const disableArrows = pages === 1;
    if (prev) prev.disabled = disableArrows;
    if (next) next.disabled = disableArrows;

    updateActiveDot(slider);
  }

  function updateActiveDot(slider) {
    const track = slider.querySelector("[data-cts-track]");
    const dotsWrap = slider.querySelector("[data-cts-dots]");
    if (!track || !dotsWrap) return;

    const dots = Array.from(dotsWrap.querySelectorAll(".cts__dot"));
    if (!dots.length) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 0) {
      // keep first active
      dots.forEach((d, i) => d.classList.toggle("is-active", i === 0));
      return;
    }

    const progress = track.scrollLeft / maxScroll;
    const idx = Math.min(
      dots.length - 1,
      Math.max(0, Math.round(progress * (dots.length - 1)))
    );

    dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
  }

  // Init on normal load
  const initAll = () => {
    document.querySelectorAll(".cts").forEach(initCTS);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor: init when section gets (re)loaded
  document.addEventListener("shopify:section:load", (e) => {
    const sectionRoot = e.target;
    if (!sectionRoot) return;

    const cts = sectionRoot.querySelector(".cts");
    if (cts) {
      // allow re-init after reload
      cts.dataset.ctsInit = "0";
      initCTS(cts);
    }
  });
})();
